// Command Report Dashboard

import React from "react";

// Custom
import Layout from "../../layout";
import MeterCommandReport from "../../components/commandReportCards/MeterCommandReport";

const CommandReportDashboard: React.FC = () => {
  return (
    <Layout>
      <MeterCommandReport />
    </Layout>
  );
};

export default CommandReportDashboard;
